import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Filters from "../../../../components/Filter/filters";
import Loading from "../../../../components/Loading";
import PasswordModal from "../../../../components/PasswordModal";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      searched: false,
      passwordModal: { show: false, id: null }
    };
    this.filter = this.filter.bind(this);
    this.insertUser = this.insertUser.bind(this);
    this.deletebtnAction = this.deletebtnAction.bind(this);
    this.deleteManyUsers = this.deleteManyUsers.bind(this);
  }

  setComponent() {
    const role = this.props.general.active_roles.role_id;
    const group = this.props.general.active_roles.group_id;
    const region = this.props.general.active_roles.region_id;
    const school = this.props.general.active_roles.school_id;

    this.setState(
      () => ({
        active_roles: {
          role_id: role,
          group_id: group,
          region_id: region,
          school_id: school
        },
        searched: true
      }),
      () => {
        this.filter("", group, region, school);
      }
    );
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setComponent();
  }

  deletebtnAction(row) {
    axios
      .post(`${URL.api}access/user/delete/${row.id}`, null, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          toastr.success(`Sucesso`, `Usuário ${row.name} deletado com sucesso`);
          this.setState(prevState => ({
            list: prevState.list.filter(user => user.id !== row.id)
          }));
        },
        error => {
          toastr.error(`Falha ao deletar`);
          this.error(error.response.statusText);
        }
      );
  }

  deleteManyUsers(ids) {
    const obj = {
      users: ids
    };
    axios
      .post(`${URL.api}access/user/deleteMany`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          toastr.success(`Sucesso`, `Usuários deletados com sucesso`);
          this.setState(prevState => ({
            list: prevState.list.filter(user => !ids.includes(user.id))
          }));
        },
        error => {
          toastr.error(`Falha ao deletar`);
          this.error(error.response.statusText);
        }
      );
  }

  componentDidUpdate(nextProps) {
    let searchController = false;

    if (
      nextProps.general.active_roles.school_id !==
      this.state.active_roles.school_id
    ) {
      searchController = true;
    } else if (
      nextProps.general.active_roles.region_id !==
      this.state.active_roles.region_id
    ) {
      searchController = true;
    } else if (
      nextProps.general.active_roles.group_id !==
      this.state.active_roles.group_id
    ) {
      searchController = true;
    } else if (
      nextProps.general.active_roles.role_id !== this.state.active_roles.role_id
    ) {
      searchController = true;
    }

    if (searchController && !this.state.searched) {
      searchController = false;
      this.setState(
        () => ({
          searched: true
        }),
        () => {
          this.setComponent();
        }
      );
    }
  }

  filter(role, group, region, school) {
    this.setState(
      () => ({
        searched: true
      }),
      () => {
        let obj = {};

        if (role !== null || role !== "") {
          obj.role = role;
        }
        if (group !== null || group !== "") {
          obj.group = group;
        }
        if (region !== null || region !== "") {
          obj.region = region;
        }
        if (school !== null || school !== "") {
          obj.school = school;
        }
        axios
          .post(`${URL.api}access/user/listUserFilter`, obj, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(resp => {
            if (resp.data.success) {
              this.setState(
                () => ({
                  list: null
                }),
                () => {
                  if (resp.data.data.length === 0) {
                    this.setState(() => ({
                      list: [],
                      searched: false
                    }));
                  } else {
                    this.setState(
                      () => ({
                        list: resp.data.data,
                        searched: false
                      }),
                      () => {
                        this.forceUpdate();
                      }
                    );
                  }
                }
              );
            }
          })
          .catch(error => {
            if (error.response?.statusText === "Unauthorized") {
              this.props.logout(this.props.user.token);
            }
          });
      }
    );
  }

  insertUser() {
    this.props.history.push("/user/cadastro");
  }

  error(response) {
    toastr.error("Falha", response);
  }

  render() {
    const roleId = Number(this.props.general.active_roles.role_id);
    const isAdmin = roleId >= 1 && roleId <= 5;

    return (
      <div className="animated fadeIn">
        <Row>
          <Breadcrumb current={this.props.currentRoute} />
          <Filters
            key={JSON.stringify(this.props.general.active_roles)}
            initial="group"
            type="hierarchy"
            group
            region
            school
            action={this.filter}
          />
          {this.state.list ? (
            <div id="list">
              <DataTable
                list={this.state.list}
                path={isAdmin ? "user/edit/" : undefined}
                title="Usuários"
                header={[
                  { name: "id", denomination: "ID" },
                  { name: "role_name", denomination: "Perfil" },
                  { name: "name", denomination: "Nome" },
                  { name: "username", denomination: "Usuário" },
                  { name: "email", denomination: "E-mail" }
                ]}
                insert={isAdmin}
                action={isAdmin}
                btnEdit={isAdmin}
                btnPassword
                delete={isAdmin}
                deletebtnAction={isAdmin ? this.deletebtnAction : undefined}
                deleteAction={isAdmin ? this.deleteManyUsers : undefined}
                passwordAction={row =>
                  this.setState({ passwordModal: { show: true, id: row.id } })
                }
                insertAction={isAdmin ? this.insertUser : undefined}
              />
            </div>
          ) : (
            <Loading />
          )}
        </Row>
        <ProtectedRoute routeId={this.props.currentRoute} />
        {this.state.passwordModal.show && (
          <PasswordModal
            show={this.state.passwordModal.show}
            id={this.state.passwordModal.id}
            onClose={() =>
              this.setState({ passwordModal: { show: false, id: null } })
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
